import { render } from "./message-text.vue?vue&type=template&id=1a816165&scoped=true&ts=true"
import script from "./message-text.vue?vue&type=script&lang=ts"
export * from "./message-text.vue?vue&type=script&lang=ts"

import "./message-text.vue?vue&type=style&index=0&id=1a816165&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a816165"]])

export default __exports__